import React from "react";
import Navbar from "../navbar/Navbar";
import Body from "../body/Body";
import Footer from "../footer/Footer";

const HomeIndex=()=>{
    return(
        <>
            <Navbar/>
            <Body />
            <Footer/>

        </>
    )
}
export default HomeIndex;